import { useState, useEffect } from 'react';
import { EnhancedSearchBar } from './EnhancedSearchBar';
import { MobileFullscreenSearch } from './map-layout/MobileFullscreenSearch';

interface ResponsiveSearchBarProps {
  onSearch: (query: string, coordinates?: [number, number]) => Promise<void>;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  className?: string;
  compact?: boolean;
}

export function ResponsiveSearchBar({
  onSearch,
  placeholder = "Search destinations...",
  value = '',
  onChange,
  onFocus,
  onBlur,
  className,
  compact
}: ResponsiveSearchBarProps) {
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // For mobile, use the clean MobileFullscreenSearch design
  if (isMobile) {
    return (
      <MobileFullscreenSearch
        onSearch={onSearch}
        placeholder={placeholder}
        className={`
          ${className}
          !max-w-md mx-auto
          !bg-white/98 backdrop-blur-xl
          shadow-2xl hover:shadow-3xl
          transition-all duration-300
          border border-white/30
          !rounded-2xl
        `}
      />
    );
  }

  // For desktop, use the existing EnhancedSearchBar
  return (
    <EnhancedSearchBar
      onSearch={onSearch}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      className={className}
      compact={compact}
    />
  );
} 